import axios from "axios";
import { CommonTexts as Texts} from "../helpers/LayoutTexts";
import { OnlineClassSearchCriteria } from "../models/OnlineClassSearchCriteria";

export async function getClassWeeks(searchModel: OnlineClassSearchCriteria, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "online-classes/week-search-results-by-admin", {
            headers: {
                'Authorization' : `Bearer ${token}`
            },
            params: searchModel
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function saveClassWeekChanges(formData: FormData, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(Texts.apiBaseUrl + "online-classes/save-week-changes-by-admin?adminId=" + adminId, formData, {
            headers: {                
                'Authorization' : `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}